/*************************************************/
/* SEARCH                                        */
/*************************************************/

export function search() {
    const suggestionsSelector = '.search-suggestions';
    const searchFormSelector = '#searchForm';
    const searchFilterOptionSelector = 'input[name="searchFilterOption"]';
    const searchResultSelector = '.search-result';
    var typeTimer;

    const getAndDisplaySearchResults = query => {
        const endpointUrl = document.querySelector(searchFormSelector).getAttribute('action');
        fetch(`${endpointUrl}?altTemplate=searchSuggestions&q=${query}`)
            .then(response => {
                return response.text();
            }).then(data => {
                document.querySelector.insertAdjacentHTML('beforeend', data);
                document.querySelector.style.display = 'block';
            }).catch(err => {
                console.log('Something went wrong in search fetch');
                console.error(err);
            });
    };

    const init = () => {
        const searchFormInput = document.querySelector(`${searchFormSelector} input`);
        if (searchFormInput) {
            searchFormInput.addEventListener('keyup', () => {
                const searchForm = document.querySelector(searchFormSelector);
                if (searchForm.dataset.showSuggestions === 'False') return;
                searchForm.remove();
                const query = searchFormInput.value;
                clearTimeout(typeTimer);
                typeTimer = setTimeout(() => {
                    getAndDisplaySearchResults(query);
                }, 500);
            });
        }

        document.addEventListener('click', e => {
            const clickTarget = e.target;
            let searchResultBox = document.querySelector(suggestionsSelector);
            if (searchResultBox && clickTarget !== searchResultBox && !clickTarget.closest(suggestionsSelector)) {
                searchResultBox.remove();
            }
        });

        const searchFilterOptions = document.querySelectorAll(searchFilterOptionSelector);
        if (searchFilterOptions) {
            searchFilterOptions.forEach(option => {
                option.addEventListener('click', e => {

                    const checkedOptions = document.querySelectorAll(searchFilterOptionSelector + ':checked');
                    const searchResults = document.querySelectorAll(searchResultSelector);

                    if (searchResults) {

                        if (checkedOptions) {
                            searchResults.forEach(searchResult => {
                                searchResult.style.display = 'none';

                                checkedOptions.forEach(checkedOption => {
                                    if (searchResult.dataset.filterAlias == checkedOption.value) {
                                        searchResult.style.display = 'block';
                                    }
                                });
                            });

                        } else {
                            searchResults.forEach(searchResult => {
                                searchResult.style.display = 'block';
                            });
                        }
                    }
                });
            });
        }
    };

    init();
}
